var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index},[_c('v-checkbox',{attrs:{"value":item,"label":item,"input-value":_vm.checkValue},on:{"input":function($event){return _vm.$emit($event.target.item)}},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }